import React, { useContext, useEffect, useState } from "react";
import consumosContext from "../../context/consumosContext/consumosContext";
import SearchInput from "../../components/searchInput/SearchInput";
import ConsumosList from "../../components/consumosList/ConsumosList";

import './Consumos.css';
import controlContext from "../../context/control/controlContext";
import { ALERTSProcedimientosProgramados, STATES, TIPPROCS } from "../../utils/states";
import authContext from "../../context/authentication/authContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import FilterScreen from "../../components/filterScreen/FilterScreen";
import AddFilter from "../../components/addFilter/AddFilter";

const Consumos = () => {

    const [filter,setFilter] = useState('');
    const [consumosFiltrados,setConsumosFiltrados] = useState(undefined);
    const [loading,setLoading] = useState(true);
    const [select,setSelect] = useState([]);
    const [filterTipoActivos,setFilterTipoActivos] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [showFilters,setShowFilters] = useState(false);

    const auContext = useContext(authContext);
    const { usuario } = auContext;

    const uContext = useContext(usuariosContext);
    const {userListView, actualizarUserListView} = uContext

    const consContext = useContext(consumosContext);
    const {consumosList, actualizarConsumos} = consContext;

    const ctrlContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango, 
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        filtrar
    } = ctrlContext;


    const aplicarFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    const handlerInicializarFiltros = async () => {
        const state = STATES;
        const tipoAlerta = ALERTSProcedimientosProgramados;
        //let statesProcs = (statusToDisplay != null) ? (statusToDisplay == 'todos') ? ['PEND','PROG','COMPL'] : ['PEND','PROG'] : ['PEND','PROG','COMPL'];
        let statesProcs = ['PEND','PROG','COMPL'];
        await iniciarFiltros(state, usuario, tipoAlerta, TIPPROCS, 'consumos', statesProcs);
    }

    useEffect(()=>{
        if(usuario) actualizarUserListView(usuario);
        handlerInicializarFiltros();
        actualizarConsumos()
        .then(res =>{
            setLoading(false);
        });
        handlerInicializarFiltros();
    },[])

    useEffect(()=>{
        if(consumosList != undefined && consumosList != null){
            let consFiltradosToSet = filtrar(consumosList,filtrosEstado,filtrosRango,'Consumos');            
            setConsumosFiltrados(consFiltradosToSet);
        };
    },[consumosList,filtrosEstado,filtrosRango]);


    return <div className="consumosView">
        <div className="utilitiesDiv">
            <FilterScreen verFiltro={setShowFilters}/>
            <SearchInput filter={filter} buscar={setFilter}/>
        </div>
        {loading ? <h3 className='warningStatusMsg'>
            Cargando<span>.</span><span>.</span><span>.</span>
        </h3> : (consumosFiltrados.length == 0) ? <h3 className="warningStatusMsg">No hay registros de consumos cargados</h3> :<ConsumosList consumos={consumosFiltrados} filter={filter} getProductsByNroFor={getProductsByNroFor} usuario={usuario}/>
        }
        
        {showFilters && <div className="filterContainer">
            <AddFilter
            usuarios={userListView} item={selectedFilter} 
            cerrar={setShowFilters} filtro={{filtrosRango, filtrosEstado}} aplicarFiltros={aplicarFiltros} 
            workspace={undefined} selct={select} setSelec={setSelect} filterTipoActivos={filterTipoActivos} setFilterTipoActivos={setFilterTipoActivos} componentePadre="Consumos"/>
        </div>
        }
    </div>

}

export default Consumos;